import Dexie, {DexieOptions, Table} from 'dexie';
import {
    IApiRoute,
    IAppSetting,
    IClientRoute,
    IDatabase,
    IFormConfig,
    ILocalisationMessage
} from '@src/@interfaces/services/Database';
import ClientRoute from '@src/services/Database/Models/ClientRoute';
import ApiRoute from '@src/services/Database/Models/ApiRoute';
import AppSetting from '@src/services/Database/Models/AppSetting';
import LocalisationMessage from '@src/services/Database/Models/LocalisationMessage';
import FormConfig from '@src/services/Database/Models/FormConfig';
import {INavigationSetting} from '@src/@interfaces/services/Database/INavigationSetting';
import NavigationSetting from '@src/services/Database/Models/NavigationSetting';
import {IModelConfig} from '@src/@interfaces/services/Database/IModelConfig';
import ModelConfig from '@src/services/Database/Models/ModelConfig';
import {IWorkSchedule} from '@src/@interfaces/services/Database/IWorkSchedule';
import WorkSchedule from '@src/services/Database/Models/WorkSchedule';

export default class Database extends Dexie implements IDatabase {
    readonly versionNumber: number = 1.1;

    settings!: Table<IAppSetting, number>;
    apiRoutes!: Table<IApiRoute, number>;
    clientRoutes!: Table<IClientRoute, number>;
    formsConfigs!: Table<IFormConfig, number>;
    localisations!: Table<ILocalisationMessage, number>;
    navigationSettings!: Table<INavigationSetting, number>;
    modelsConfigs!: Table<IModelConfig, number>;
    workSchedule!: Table<IWorkSchedule, number>;

    constructor(databaseName = 'main-database', options?: DexieOptions) {
        super(databaseName, options);

        this.version(this.versionNumber).stores({
            settings: '++id, name, &[name+service]',
            apiRoutes: '++id, &name',
            clientRoutes: '++id, &name',
            formsConfigs: '++id, &name',
            localisations: '++id, &[locale+component+key]',
            navigationSettings: '++id, &name',
            modelsConfigs: '++id, &[model+name]',
            workSchedule: '++id, &key',
        });

        this.settings.mapToClass(AppSetting);
        this.apiRoutes.mapToClass(ApiRoute);
        this.clientRoutes.mapToClass(ClientRoute);
        this.formsConfigs.mapToClass(FormConfig);
        this.localisations.mapToClass(LocalisationMessage);
        this.navigationSettings.mapToClass(NavigationSetting);
        this.modelsConfigs.mapToClass(ModelConfig);
        this.workSchedule.mapToClass(WorkSchedule);
    }

    refresh() {
        this.delete().then(() => {
            this.open();
        });
    }
}
